import Module from './Module.vue';
import Transaksi from './views/Transaksi.vue';
import TransaksiDetail from './views/TransaksiDetail.vue';

const modalTolak = () => {
  return import('./components/SOTolakModal.vue');
}

const modalTerima = () => {
  return import('./components/SOTerimaModal.vue');
}

const modalExport = () => {
  return import('./components/SOExportModal.vue');
}

const moduleRoute = {
  path: '/pembatalan_topup_deposit',
  component: Module,
  meta: {requireAuth: true},
  children: [
    {
      path: '',
      name: 'PembatalanTopupDeposit.list',
      component: Transaksi,
      meta: {
				requireAuth: true,
				accessKey: 'transaction.deleteTopupDeposit',
			},
    },
    {
      path: 'detail/:id',
      component: Module,
      meta: {requireAuth: true},
      children: [
        {
          path: '',
          name: 'PembatalanTopupDeposit.detail.data',
          component: TransaksiDetail,
          meta: {
            requireAuth: true,
            accessKey: 'deleteTopupDeposit.read',
          },
        },
        {
          path: 'tolak',
          name: 'PembatalanTopupDeposit.detail.tolak',
          components: {
            default: TransaksiDetail,
            dialog: modalTolak
          },
          meta: {
            requireAuth: true,
            accessKey: 'deleteTopupDeposit.confirm'
          },
        },
        {
          path: 'terima',
          name: 'PembatalanTopupDeposit.detail.terima',
          components: {
            default: TransaksiDetail,
            dialog: modalTerima
          },
          meta: {
            requireAuth: true,
            accessKey: 'deleteTopupDeposit.confirm',
          },
        },
      ]
    },
    {
      path: 'tolak',
      name: 'PembatalanTopupDeposit.tolak',
      components: {
        default: Transaksi,
        dialog: modalTolak
      },
      meta: {
        requireAuth: true,
        accessKey: 'deleteTopupDeposit.confirm',
      },
    },
    {
      path: 'terima',
      name: 'PembatalanTopupDeposit.terima',
      components: {
        default: Transaksi,
        dialog: modalTerima
      },
      meta: {
        requireAuth: true,
        accessKey: 'deleteTopupDeposit.confirm'
      },
    },
    {
      path: 'export',
      name: 'PembatalanTopupDeposit.export',
      components: {
        default: Transaksi,
        dialog: modalExport
      },
      meta: {requireAuth: true},
    },
  ]
};

export default router => {
  router.addRoutes([moduleRoute])
}